"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRAND_API_MESSAGES = exports.BRAND_API_ERRORS = void 0;
/** Machine codes. They ride in the error body's `error` field, the one custom field the API's filter keeps. */
exports.BRAND_API_ERRORS = {
    V2_OFF: 'BRAND_WORKSPACE_V2_OFF',
    NO_ACCESS: 'BRAND_NO_ACCESS',
    ADMIN_ONLY: 'BRAND_ADMIN_ONLY',
    VERSION_CONFLICT: 'BRAND_VERSION_CONFLICT',
    NAME_REQUIRED: 'WORKSPACE_NAME_REQUIRED',
    WEBSITE_REQUIRED: 'WEBSITE_REQUIRED',
    WEBSITE_INVALID: 'WEBSITE_INVALID',
    FIELDS_MOVED: 'BRAND_FIELDS_MOVED',
    READ_ONLY_FIELD: 'BRAND_READ_ONLY_FIELD',
    STEP_MISMATCH: 'BRAND_STEP_MISMATCH',
    FIELD_INVALID: 'BRAND_FIELD_INVALID',
    AUDIENCE_NOT_FOUND: 'BRAND_AUDIENCE_NOT_FOUND',
};
/** The server's words for those codes; the web shows 400 and 409 messages as they are. */
exports.BRAND_API_MESSAGES = {
    V2_OFF: 'Not found',
    NO_ACCESS: "You don't have access to that Brand Workspace.",
    ADMIN_ONLY: 'Only a Brand Workspace admin can change your brand settings.',
    VERSION_CONFLICT: "Your brand's details were changed in another tab or by another admin. Reload to get the latest version, then make your changes again.",
    NAME_REQUIRED: 'Enter a name for your Brand Workspace.',
    FIELDS_MOVED_PATCH: 'This is now saved on the Brand information page. Reload the page and try again.',
    FIELDS_MOVED_CREATE: 'New Brand Workspaces start with empty brand fields. Add them in Brand Setup.',
    READ_ONLY_FIELD: 'Change this in Brand Setup.',
    STEP_MISMATCH: "That isn't part of this step. Reload Brand Setup and try again.",
    AUDIENCE_NOT_FOUND: 'One of these audiences was removed somewhere else. Reload to see the latest.',
};
//# sourceMappingURL=brand-profile.js.map